<template>
    <div v-if="showOutput" :class="[col9 ? 'col-3 col-md-9 mb-3 row' : 'row']" class="py-3 px-3 mr-0 ml-0">
        <div v-if="parentKey && !dataSet?.key_formatted && parentKey !== 'editable'" class="mb-3 py-3 border-bottom">
            <strong>{{ parentKey }}</strong>
        </div>

        <template v-for="(value, key, index) in this.dataSet">
            <div v-if="typeof value !== 'object' && key == 'key_formatted'" class="col-9 col-md-3 mb-1">
                <strong>{{ value }}</strong>
            </div>
            <div v-else-if="typeof value !== 'object' && key == 'value'" class="col-9">
                {{ value }}
            </div>
            <!-- <hr v-if="typeof value === 'object' && index === Object.keys(dataSet).length - 1" /> -->
        </template>
    </div>
</template>
<script>
export default {
    name: 'ViewJsonSingleElement',
    props: ['dataSet', 'parentKey', 'col9'],
    data() {
        return {
            status: 'No Status',
            showOutput: false,
        };
    },
    mounted: function () {
        this.showOutput = true;
    },
    methods: {},
};
</script>
<style>
.scroll-height {
    height: calc(100vh - 80px);
}
.grayBackground {
    background-color: #d4d4d4;
}
</style>
